import { useEffect, useState } from 'react'

import { Box, Text } from '@factorialco/deprecated-design-system'
import { F0Icon } from '@factorialco/f0-react'
import AlertCircle from '@factorialco/f0-react/icons/app/AlertCircle'

import i18n from 'modules/core/lib/i18n'

import { SyncReviewModal } from 'modules/integrations/components/SyncButton/Modals/SyncReviewModal'
import { Separator } from 'modules/integrations/components/SyncFooter/Separator'
import { usePrivateIntegrationsSyncContext } from 'modules/integrations/hooks/SyncContext'
import { useSyncIssuesLazyQuery } from 'modules/integrations/hooks/SyncContext/useSyncIssuesLazyQuery'

export const Issues = () => {
  const { marketplaceIntegration, syncEnabled, contextParameters, capabilityMode } =
    usePrivateIntegrationsSyncContext()
  const { fetchIssues, issues, anyValidSyncable } = useSyncIssuesLazyQuery()
  const [isModalOpen, setIsModalOpen] = useState(false)
  const serializedContextParameters = JSON.stringify(contextParameters)

  const isExportMode = capabilityMode === 'file'

  useEffect(() => {
    fetchIssues()
  }, [marketplaceIntegration?.id, syncEnabled, serializedContextParameters])

  if (issues.length === 0) return null

  const modalTitle = isExportMode
    ? i18n.t('integrations.sync_review_modal.export_title')
    : i18n.t('integrations.sync_review_modal.sync_title')

  const modalDescription = anyValidSyncable
    ? isExportMode
      ? i18n.t('integrations.sync_review_modal.export_warning_description')
      : i18n.t('integrations.sync_review_modal.sync_warning_description')
    : isExportMode
      ? i18n.t('integrations.sync_review_modal.export_description')
      : i18n.t('integrations.sync_review_modal.sync_description')

  return (
    <>
      <Box flexDirection="row" cursor="pointer" onClick={() => setIsModalOpen(true)}>
        <Text.Normal color="radicalRed800" size="100">
          <F0Icon icon={AlertCircle} type="warning" />
        </Text.Normal>
        <Text.Normal color="radicalRed1500" size="200" weight="medium" underlined>
          {i18n.tp('integrations.footer.issues', { count: issues.length })}
        </Text.Normal>
      </Box>
      <Separator />
      {isModalOpen && (
        <SyncReviewModal
          onClose={() => setIsModalOpen(false)}
          issues={issues}
          anyValidSyncable={anyValidSyncable}
          title={modalTitle}
          description={modalDescription}
        />
      )}
    </>
  )
}
